export default __webpack_public_path__ + "static/media/banner5.46ff5fd8.png";